var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7329 7.5C22.7329 11.3676 19.6005 14.5 15.7329 14.5C11.8653 14.5 8.73291 11.3676 8.73291 7.5C8.73291 3.63239 11.8653 0.5 15.7329 0.5C19.6005 0.5 22.7329 3.63239 22.7329 7.5ZM1.23291 26.25C1.23291 25.1868 1.76156 24.2184 2.71177 23.3414C3.66538 22.4613 5.00991 21.7074 6.5415 21.0938C9.60549 19.8664 13.2923 19.25 15.7329 19.25C18.1735 19.25 21.8603 19.8664 24.9243 21.0938C26.4559 21.7074 27.8004 22.4613 28.7541 23.3414C29.7043 24.2184 30.2329 25.1868 30.2329 26.25V29.5H1.23291V26.25Z",
    fill: "#EBEBEB",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReportIcon);
export default __webpack_public_path__ + "static/media/UserReportIcon.535a3fc0fb8c84b7c66db6f6f0e3919d.svg";
export { ForwardRef as ReactComponent };